(() => {
  const bar = document.getElementById('BookiliciousCurrency');
  if (!bar || bar.dataset.base !== 'AED') return;
  const select = document.getElementById('BookiliciousCurrencySelect');
  const status = document.getElementById('BookiliciousCurrencyStatus');
  const credit = bar.querySelector('.bookilicious-currency__credit');
  const preferenceKey = 'bookilicious-display-currency-v1';
  const rateKey = 'bookilicious-aed-pkr-rate-v1';
  const countryKey = 'bookilicious-detected-country-v1';
  const originals = new WeakMap();
  const amount = '(?:\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.\\d{1,2})?';
  const pattern = new RegExp('(?:Dhs\\.?|AED|د\\.إ)\\s*(' + amount + ')(?:\\s*AED)?|(' + amount + ')\\s*(?:AED|د\\.إ)', 'g');
  const numberFormat = new Intl.NumberFormat(document.documentElement.lang === 'ar' ? 'ar-AE' : 'en-PK', {maximumFractionDigits: 0});
  const read = (storage, key) => { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const getJson = async (url, timeout = 5000, external = false) => {
    const control = new AbortController();
    const timer = setTimeout(() => control.abort(), timeout);
    try {
      const response = await fetch(url, {signal: control.signal, credentials: external ? 'omit' : 'same-origin', referrerPolicy: external ? 'no-referrer' : 'strict-origin-when-cross-origin'});
      if (!response.ok) throw new Error('Request unavailable');
      return await response.json();
    } finally { clearTimeout(timer); }
  };
  let preference = read(localStorage, preferenceKey);
  if (!['auto', 'AED', 'PKR'].includes(preference)) preference = 'auto';
  let detectedCountry = bar.dataset.country;
  let rate = null;
  let rateRequest = null;
  let generation = 0;
  let display = 'AED';
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; renderPrices(); });
  });
  function renderPrices() {
    observer.disconnect();
    try {
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.parentElement || node.parentElement.closest('script,style,noscript,textarea,select,button,input,svg,iframe,[contenteditable="true"],#BookiliciousCurrency')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      let node;
      while ((node = walker.nextNode())) {
        let record = originals.get(node);
        if (record && node.nodeValue !== record.output) {
          originals.delete(node);
          record = null;
        }
        const source = record ? record.source : node.nodeValue;
        pattern.lastIndex = 0;
        if (!record && !pattern.test(source)) continue;
        pattern.lastIndex = 0;
        const output = display === 'PKR' && rate ? source.replace(pattern, (_, first, second) => '≈ PKR ' + numberFormat.format(Number((first || second).replace(/,/g, '')) * rate)) : source;
        originals.set(node, {source, output});
        if (node.nodeValue !== output) node.nodeValue = output;
      }
    } finally { observer.observe(document.body, {subtree:true, childList:true, characterData:true}); }
  }
  async function fetchRate() {
    if (rate) return rate;
    if (rateRequest) return rateRequest;
    rateRequest = (async () => {
      const cache = read(localStorage, rateKey);
      const valid = cache && Number.isFinite(cache.rate) && cache.rate > 0 && Date.now() - cache.updatedAt < 172800000;
      if (valid && Date.now() < cache.nextUpdate) return cache.rate;
      try {
        const json = await getJson('https://open.er-api.com/v6/latest/AED', 5000, true);
        if (json.result !== 'success' || json.base_code !== 'AED' || !Number.isFinite(json.rates?.PKR) || json.rates.PKR <= 0 || !Number.isFinite(json.time_last_update_unix) || Date.now() - json.time_last_update_unix * 1000 > 172800000) throw new Error('Rate unavailable');
        write(localStorage, rateKey, {rate:json.rates.PKR, updatedAt:json.time_last_update_unix * 1000, nextUpdate:Math.min(json.time_next_update_unix * 1000, Date.now() + 86400000)});
        return json.rates.PKR;
      } catch (error) {
        if (valid) return cache.rate;
        throw error;
      }
    })();
    try { return await rateRequest; } finally { rateRequest = null; }
  }
  async function applyPreference() {
    const currentGeneration = ++generation;
    const requested = preference === 'auto' ? (detectedCountry === 'PK' ? 'PKR' : 'AED') : preference;
    select.value = preference;
    if (requested === 'PKR') {
      status.textContent = bar.dataset.loading;
      try { rate = await fetchRate(); }
      catch (_) {
        if (currentGeneration !== generation) return;
        display = 'AED';
        credit.hidden = true;
        status.textContent = bar.dataset.unavailable;
        renderPrices();
        return;
      }
    }
    if (currentGeneration !== generation) return;
    display = requested;
    bar.dataset.displayCurrency = display;
    status.textContent = display === 'PKR' ? bar.dataset.estimate : bar.dataset.aed;
    credit.hidden = display !== 'PKR';
    renderPrices();
  }
  select.addEventListener('change', () => {
    preference = select.value;
    write(localStorage, preferenceKey, preference);
    applyPreference();
  });
  bar.hidden = false;
  select.value = preference;
  status.textContent = bar.dataset.loading;
  (async () => {
    if (preference !== 'auto') applyPreference();
    {
      const cached = read(sessionStorage, countryKey);
      if (cached?.country && Date.now() - cached.at < 3600000) detectedCountry = cached.country;
      else {
        try {
          const root = bar.dataset.root.endsWith('/') ? bar.dataset.root : bar.dataset.root + '/';
          const data = await getJson(root + 'browsing_context_suggestions.json?country[enabled]=true', 3500);
          const country = data.detected_values?.country?.handle;
          if (/^[A-Z]{2}$/.test(country || '')) {
            detectedCountry = country;
            write(sessionStorage, countryKey, {country, at:Date.now()});
          }
        } catch (_) {}
      }
    }
    if (preference === 'auto') applyPreference();
  })();
})();
